import type { ConceptContentData } from "../types";
import { ConceptCodeBlock, ConceptText } from "./components";

type TargetsAndGoalsContent = Extract<
  ConceptContentData,
  { slug: "targets-and-goals" }
>;

export function TargetsAndGoalsConcept({
  content,
}: {
  content: TargetsAndGoalsContent;
}) {
  return (
    <div className="grid gap-7">
      <dl className="border-border grid border-y md:grid-cols-2 md:divide-x">
        {content.definitions.map((definition, index) => (
          <div
            key={definition.id}
            id={definition.id}
            className={
              index === 0
                ? "grid scroll-mt-20 content-start gap-2 py-5 md:pr-6"
                : "border-border grid scroll-mt-20 content-start gap-2 border-t py-5 md:border-t-0 md:pl-6"
            }
          >
            <dt className="font-semibold">{definition.term}</dt>
            <dd className="text-muted-foreground leading-7">
              <ConceptText text={definition.body} />
            </dd>
          </div>
        ))}
      </dl>

      <ConceptCodeBlock
        caption={content.exampleCaption}
        lines={content.exampleLines}
      />

      <section
        className="border-border grid scroll-mt-20 gap-2 border-l-2 pl-4"
        id="default-goal"
      >
        <h2 className="font-semibold">Default goal</h2>
        <p className="text-muted-foreground max-w-3xl leading-7">
          <ConceptText text={content.defaultGoal} />
        </p>
      </section>

      <p className="text-muted-foreground max-w-3xl leading-7">
        <ConceptText text={content.conclusion} />
      </p>
    </div>
  );
}
